import {createContext, useContext} from 'react';

type SequentialModalContextType = {
  onClose: () => void;
  modalIndex: number;
  totalModals: number;
  isLastModal: boolean;
  isFirstModal: boolean;
  goToNext: () => void;
  goToPrevious: () => void;
  goToIndex: (index: number) => void;
};

const SequentialModalContext = createContext<SequentialModalContextType | null>(
  null,
);

export const useSequentialModalContext = () => {
  const context = useContext(SequentialModalContext);
  if (!context) {
    throw new Error(
      'useSequentialModalContext must be used within a SequentialModalProvider',
    );
  }
  return context;
};

export {SequentialModalContext};
